import { render, staticRenderFns } from "./CoberturaEstoque.vue?vue&type=template&id=f9808894&scoped=true"
import script from "./CoberturaEstoque.vue?vue&type=script&lang=js"
export * from "./CoberturaEstoque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9808894",
  null
  
)

export default component.exports